export type TLocalizedMessage = {
  title?: string
  body: string
}

export type TLocalizedMessages = {
  en: TLocalizedMessage
  es: TLocalizedMessage
  fr: TLocalizedMessage
  ja: TLocalizedMessage
  zh: TLocalizedMessage
  ru: TLocalizedMessage
  de: TLocalizedMessage
  pt: TLocalizedMessage
  hi: TLocalizedMessage
  id: TLocalizedMessage
  he: TLocalizedMessage
  ko: TLocalizedMessage
  it: TLocalizedMessage
  ar: TLocalizedMessage
}
